import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/organisms/AlternateLanguageSetter/partials/PathnameBasedPageSetter/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/images/ellipse-timer.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/logo.svg");
